module.exports = __webpack_public_path__ + "img/game6.2834fe77.png";